// Module 08's sidebar contribution (v3 DefaultLayout.vue:211–556, report groups only) —
// composed by the shell via `registerShellNavigation`. Visibility rules are the typed
// `useNavVisibility` controls; report-backed leaves carry NO labelKey on purpose: the nav
// engine derives `reports.<reportKey>.title` from the bootstrap report's machine key
// (v3 parity — those labels were BE-named). Groups and non-report leaves use explicit keys.
//
// Module 25 owns the complete Marketing Insights group through registry composition; 08 carries
// no duplicate group or leaves. The live New Front tree is the placement authority: App
// Acquisition belongs under Budget & Performance, Product Insights belongs under Ecommerce,
// and App Analytics remains commented out.

export const reportNavItems = [
  {
    labelKey: 'reports.nav.creativePerformance',
    icon: 'folder-image',
    navKey: 'creativePerformanceGroup',
    visibility: { control: 'report' as const, id: [13] },
    children: [
      {
        navKey: 'creativeDashboard',
        to: { name: 'CreativeDashboard' },
        visibility: { control: 'report' as const, id: [13] },
      },
      {
        labelKey: 'reports.nav.creativeWatchlist',
        navKey: 'creativeWatchlist',
        to: { name: 'CreativeWatchlist' },
        visibility: { control: 'report' as const, id: [13] },
        meta: {
          importance: 9,
          searchValue:
            'Creative Watchlist Google Meta advertiser creatives first shown last shown impressions ad library',
        },
      },
    ],
  },
  {
    labelKey: 'reports.nav.budgetPerformance',
    icon: 'chart-line-up',
    navKey: 'budgetPerformanceGroup',
    hidePermission: 'hide_report_6',
    visibility: { control: 'report' as const, id: [6, 68, 66, 18] },
    children: [
      {
        navKey: 'budgetAllocation',
        to: { name: 'BudgetAllocation' },
        hidePermission: 'hide_report_6',
        visibility: { control: 'report' as const, id: [6, 68, 66] },
      },
      {
        // New Front moved this leaf out of the now-commented App Analytics group.
        labelKey: 'reports.pages.appAcquisition',
        navKey: 'appAcquisition',
        to: { name: 'MobileAppAcquisition' },
        visibility: { control: 'report' as const, id: [18] },
      },
    ],
  },
  {
    labelKey: 'reports.nav.audience',
    icon: 'user',
    navKey: 'audienceGroup',
    visibility: {
      control: 'multiple' as const,
      id: [
        // 67 included per v3 parity (DefaultLayout.vue:406 — `Report [28, 70, 67]`): a workspace
        // holding only the RFM report must still see the group, or its RFM leaf is unreachable.
        { control: 'report' as const, id: [28, 70, 67] },
        { control: 'integration' as const, id: ['ga4'] },
      ],
    },
    children: [
      {
        navKey: 'demographicAnalysis',
        to: { name: 'DemographicAnalysis' },
        visibility: { control: 'report' as const, id: [70] },
        meta: {
          importance: 5,
          searchValue:
            'Demographic Analysis Age Gender Location Audience Audience Segments Device Behavior Interest Search Terms Meta Ads TikTok Ads targeting campaign performance creatives audiences formats ROI',
        },
      },
      {
        labelKey: 'reports.nav.rfmAnalysis',
        navKey: 'rfmClustering',
        to: { name: 'RFMClustering' },
        visibility: { control: 'scheduleTab' as const, id: 67, tabs: ['overview'] },
      },
    ],
  },
  {
    labelKey: 'reports.nav.ecommerce',
    icon: 'cart-shopping',
    navKey: 'ecommerceGroup',
    visibility: { control: 'reportEcommerce' as const, id: [67, 17, 48, 53] },
    children: [
      {
        navKey: 'productPerformance',
        to: { name: 'ProductPerformance' },
        visibility: { control: 'report' as const, id: [17, 48] },
      },
    ],
  },
  {
    labelKey: 'reports.nav.travel',
    icon: 'plane-departure',
    navKey: 'travelGroup',
    visibility: { control: 'report' as const, id: [69] },
    children: [
      {
        navKey: 'hotelAds',
        to: { name: 'HotelAdsAnalysis' },
        visibility: { control: 'report' as const, id: [69] },
      },
    ],
  },
]
